import { CalcModule } from './calc/calc.module';
import { ExplorerModule } from './explorer/explorer.module';
import { LoginModule } from './login/login.module';
import { TerminalModule } from './terminal/terminal.module';
import { UserProfileModule } from './user-profile/user-profile.module';
import { ViewerModule } from './viewer/viewer.module';

/** @todo Re-design the internal dynamic apps system. Info: https://indepth.dev/dynamically-loading-components-with-angular-cli */
export const InternalApps = [
  { name: "profile", module: UserProfileModule },
  { name: "calc", module: CalcModule },
  { name: "explorer", module: ExplorerModule },
  { name: "login", module: LoginModule },
  { name: "terminal", module: TerminalModule },
  { name: "viewer", module: ViewerModule, assotiations: ["*"] },
];
